import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageService from "../APIService/LanguageService";
import English from "../json/en.json";

/**
 * Load translations from API
 */
const loadTranslationsFromApi = async (lang: string) => {
  let response;
  if (isUserLoggedIn()) {
    response = await LanguageService.getLanguageData(lang);
  } else {
    response = await LanguageService.getLoginLanguageData(lang);
  }
  return response.data.d.Data;
};

let loadingLanguage: string | null = null;

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources: {
    en: {
      translation: English, // local fallback
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

/**
 * Check if user logged in
 */

const isUserLoggedIn = () => {
  const token = localStorage.getItem("authToken");
  return !!token;
};

/**
 * Change language safely (API → local EN fallback)
 */
export const setLanguageTranslation = async (lang: string, forceReload = false) => {
  if (i18n.language === lang && !forceReload) return;
  if (loadingLanguage === lang) return;

  loadingLanguage = lang;

  try {
    if (forceReload && i18n.hasResourceBundle(lang, "translation")) {
      i18n.removeResourceBundle(lang, "translation");
    }

    if (!i18n.hasResourceBundle(lang, "translation")) {
      const translations = await loadTranslationsFromApi(lang);

      i18n.addResourceBundle(
        lang,
        "translation",
        translations,
        true,
        true
      );
    }
    await i18n.changeLanguage(lang);
  } catch (error) {
    console.error(
      `Language API failed for "${lang}", falling back to EN`,
      error
    );

    if (!i18n.hasResourceBundle("en", "translation")) {
      i18n.addResourceBundle(
        "en",
        "translation",
        English,
        true,
        true
      );
    }
    await i18n.changeLanguage("en");
  } finally {
    loadingLanguage = null;
  }
};

export default i18n;
export const t = i18n.t.bind(i18n);

